var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "search-element" }, [
    _c(
      "div",
      { staticClass: "contactum-input-wrap" },
      [
        _c("span", { staticClass: "el-icon el-icon-search" }),
        _vm._v(" "),
        _c("el-input", {
          ref: "searchInput",
          staticClass: "search-field",
          attrs: { type: "text", placeholder: _vm.placeholder },
          model: {
            value: _vm.searchElementStr,
            callback: function($$v) {
              _vm.searchElementStr = $$v
            },
            expression: "searchElementStr"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.searchResult.length,
            expression: "searchResult.length"
          }
        ],
        staticClass: "search-element-result",
        staticStyle: { "margin-top": "15px" }
      },
      [_c("fields_button", { attrs: { fields: _vm.searchResult } })],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }